/// <reference path='../../../../typings/index.d.ts' />
/// <reference path='controls.module.ts' />

module Meevo.Components.Controls {
    'use strict';

    export class ImageUpload {
        restrict = 'E';
        scope = {
            context: '=',
            buttonClass: '@?',
            imageUrl: '=ngModel',
            ngDisabled: '='
        };
        replace = true;
        template = `<div>
                        <div class="section-margin-bottom" >
                            <img ng-src="{{imageUrl}}" class="company_logo" />
                        </div>
                        <button class="{{buttonClass}}" ng-disabled="ngDisabled" ng-click="openImageUpload(context)">Upload</button>
                    </div>`;

        constructor (
            private modalService: Meevo.Components.Modal.IModalService,
            private $mdDialog: ng.material.IDialogService
        ) {

        }

        link (scope: any) {
            scope.buttonClass = scope.buttonClass == undefined ? 'meevo-button': scope.buttonClass;
            scope.imageUrl = scope.imageUrl == undefined ? 'assets/images/photo_not_available.svg' : scope.imageUrl;
            scope.openImageUpload = () => {
                let options = {
                    templateUrl: 'app/components/controls/imageUploadTemplate.html',
                    clickOutsideToClose: true,
                    preserveScope: true,
                    locals: {
                        directiveScope: scope
                    },
                    controller: 'meevo.components.controls.ImageUploadController',
                    controllerAs: 'vm'
                };
                this.modalService.showCustom(options);
            };

            scope.cancel = () => {
                this.$mdDialog.cancel();
            };

            scope.apply = () => {
                this.$mdDialog.cancel();
            };

        }

        static factory (): angular.IDirectiveFactory {
            let directive;

            directive = (
                modalService: Meevo.Components.Modal.IModalService,
                $mdDialog: ng.material.IDialogService
            ) => {
                return new ImageUpload(modalService, $mdDialog);
            };

            directive.$inject = ['meevo.components.modal.ModalService', '$mdDialog'];

            return directive;
        }
    }

    angular.module('meevo.components.controls')
        .directive('imageUpload', ImageUpload.factory());
}





